// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Spacing between each Pabrika table */
.ci-table-wrapper {
  margin-bottom: 20px;
}

/* Layout for the print link above the table */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-header .print-link {
  margin-left: auto;
}

/* Styling for the print link - copied from listen pages */
.print-link {
  color: #00509E !important;
  text-decoration: none;
  font-weight: normal;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.print-link .print-text {
  color: #00509E !important;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.print-link .material-symbols-outlined {
  margin-right: 0.25rem;
  color: #00509E;
  font-variation-settings:
    'FILL' 0,
    'wght' 500,
    'GRAD' 0,
    'opsz' 40;
}

/* Column widths for the PabrikaAuslesen table */
.pabrika-table th:nth-child(1),
.pabrika-table td:nth-child(1) {
  width: 20%;
  text-align: left;
}

.pabrika-table th:nth-child(2),
.pabrika-table td:nth-child(2) {
  width: 50%;
  text-align: center;
}

.pabrika-table th:nth-child(3),
.pabrika-table td:nth-child(3) {
  width: 20%;
}

.pabrika-table th:nth-child(4),
.pabrika-table td:nth-child(4) {
  width: 10%;
}`, "",{"version":3,"sources":["webpack://./src/components/parlament/pabrika/Pabrika.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd;;;;aAIW;AACb;;AAEA,gDAAgD;AAChD;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ","sourcesContent":["/* Spacing between each Pabrika table */\n.ci-table-wrapper {\n  margin-bottom: 20px;\n}\n\n/* Layout for the print link above the table */\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.table-header .print-link {\n  margin-left: auto;\n}\n\n/* Styling for the print link - copied from listen pages */\n.print-link {\n  color: #00509E !important;\n  text-decoration: none;\n  font-weight: normal;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.print-link .print-text {\n  color: #00509E !important;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.print-link .material-symbols-outlined {\n  margin-right: 0.25rem;\n  color: #00509E;\n  font-variation-settings:\n    'FILL' 0,\n    'wght' 500,\n    'GRAD' 0,\n    'opsz' 40;\n}\n\n/* Column widths for the PabrikaAuslesen table */\n.pabrika-table th:nth-child(1),\n.pabrika-table td:nth-child(1) {\n  width: 20%;\n  text-align: left;\n}\n\n.pabrika-table th:nth-child(2),\n.pabrika-table td:nth-child(2) {\n  width: 50%;\n  text-align: center;\n}\n\n.pabrika-table th:nth-child(3),\n.pabrika-table td:nth-child(3) {\n  width: 20%;\n}\n\n.pabrika-table th:nth-child(4),\n.pabrika-table td:nth-child(4) {\n  width: 10%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
